import React from "react";
import { Anchor, Divider } from "antd";
import { releaseNotesData } from "./releaseNotesData.js";
import "./ReleaseNote.scss";

const { Link } = Anchor;

const formatDate = (dateString) => {
  const date = new Date(dateString);
  const options = { day: "numeric", month: "short", year: "numeric" };
  return date.toLocaleDateString("en-GB", options);
};

const renderNoteContent = (content) => {
  if (Array.isArray(content)) {
    return (
      <ul>
        {content.map((item, index) => (
          <li key={index}>{renderNoteContent(item)}</li>
        ))}
      </ul>
    );
  } else if (typeof content === "object" && content !== null) {
    return (
      <div>
        {Object.entries(content).map(([key, value], index) => (
          <div key={index}>
            <h3>{key}</h3>
            {renderNoteContent(value)}
          </div>
        ))}
      </div>
    );
  } else {
    return <span>{content}</span>;
  }
};
const ReleaseNotes = ({ releaseNotes }) => {
  return (
    <div className="app-container">
      <div className="sidebar">
        <h4 className="sidebar-title">Release Notes </h4>
        <Anchor affix={true}>
          {releaseNotes.map((note) => (
            <Link
              href={`#version-${note.version.replace(/\./g, "-")}`}
              title={`v${note.version}`}
              key={note.version}
            />
          ))}
        </Anchor>
      </div>

      <div className="content">
        <h4 className="title">Release Notes</h4>
        <Divider />
        {releaseNotes.map((note, index) => (
          <div
            id={`version-${note.version.replace(/\./g, "-")}`}
            key={index}
            className="note-container"
          >
            <h2>{`v${note.version} - ${formatDate(note.date)}`}</h2>
            {Object.entries(note)
              .filter(([key]) => key !== "version" && key !== "date")
              .map(([key, value], index) => (
                <div key={index}>
                  <h3>{key}</h3>
                  {renderNoteContent(value)}
                </div>
              ))}
          </div>
        ))}
      </div>
    </div>
  );
};
const App = () => {
  return (
    <>
      <ReleaseNotes releaseNotes={releaseNotesData.releaseNotes} />
    </>
  );
};

export default App;
